<script setup>
  import {MedButton, MedIcon} from "@pharma4u/medicheck-components";

  import DashboardWidget from "./Widget.vue";

  defineOptions({
    name: "DashboardPatientCountWidget",
  });
</script>

<template>
  <DashboardWidget :test-id="getTestId('patient-count')">
    <template #default>
      <MedButton
        as="inertia"
        :href="$route('patients.index')"
        flat
        class="active:scale-97"
        align="left"
        :data-test="getTestId('patient-count-widget-route-to-patient-index-inertia-link-icon-button')"
      >
        <span class="flex rounded-full bg-mcred p-1.5 font-normal text-white">
          <MedIcon icon="view_list" size="lg" />
        </span>

        <span class="text-4xl font-semibold text-gray-700">
          {{ $page.props.patientCount ?? 0 }}
        </span>

        <span class="self-end text-2xl leading-tight font-semibold text-gray-700">
          {{ $page.props.patientCount === 1 ? "Patient" : "Patienten" }}
        </span>
      </MedButton>
    </template>

    <template #actions>
      <MedButton
        variant="primary"
        as="inertia"
        :href="$route('patients.index')"
        :data-test="getTestId('patient-count-widget-patient-list-button')"
      >
        Alle Patienten
      </MedButton>
    </template>
  </DashboardWidget>
</template>
